import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { CustomDirectiveConfig, formConfigs, IApplicationResponse, ModulesBasedApiSuffix, onBlurActionOnDuplicatedFormControl, onFormControlChangesToFindDuplicate } from '@app/shared';
import { CrudService, RxjsService } from '@app/shared/services';
import { loggedInUserData } from '@modules/others';
import { SalesChannelModel } from '@modules/others/configuration/models/sales-channel-model';
import { UserLogin } from '@modules/others/models';
import { SalesModuleApiSuffixModels } from '@modules/sales';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-sales-channel',
  templateUrl: './sales-channel.component.html'
})
export class SalesChannelComponent implements OnInit {
  SalesChannelId: any;
  salesChannelForm: FormGroup;
  formConfigs = formConfigs;
  userData: UserLogin;
  submitAddArray = [];
  salesChannelArray: FormArray;
  addArray: any;
  stringConfig = new CustomDirectiveConfig({ isAStringOnly: true});
  primengTableConfigProperties: any;

  constructor(private activatedRoute: ActivatedRoute
    , private store: Store<AppState>,
    private formBuilder: FormBuilder,
    private crudService: CrudService,
    private router: Router,
    private rjxService: RxjsService) {
    this.SalesChannelId = this.activatedRoute.snapshot.queryParams.id;
    this.store.pipe(select(loggedInUserData)).subscribe((userData: UserLogin) => {
      if (!userData) return;
      this.userData = userData;
    })
    let isEditArr: any = [{ displayName: 'Add Sales Channel' }];
    if (this.SalesChannelId) {
      isEditArr = [{ displayName: 'View', relativeRouterUrl: '/configuration/sales/leads/sales-channels/view', queryParams: { id: this.SalesChannelId } }, { displayName: 'Update Sales Channel' }]
    }
    this.primengTableConfigProperties = {
      tableCaption: `${this.SalesChannelId ? 'Update' : 'Add'} Sales Channel`,
      selectedTabIndex: 0,
      breadCrumbItems: [{ displayName: 'Configuration' }, { displayName: 'Sales' }, { displayName: 'Leads', relativeRouterUrl: '/configuration/sales/leads', queryParams: { tab: 0 } }, { displayName: 'Sales Channel List', relativeRouterUrl: '/configuration/sales/leads', queryParams: { tab: 2 } },
      ...isEditArr],
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'Sales Channel',
            dataKey: 'SalesChannelId',
            enableBreadCrumb: true,
            enableHyperLink: true,
            cursorLinkIndex: 0,
            enableAddActionBtn: true,
            shouldShowDeleteActionBtn: false,
            shouldShowCreateActionBtn: true,
            areCheckboxesRequired: false,
            isDateWithTimeRequired: true,
            url: '',
          },
        ]
      }
    }
  }

  ngOnInit(): void {
    this.rjxService.setGlobalLoaderProperty(false);
    this.createSalesChannelForm();
    if (this.SalesChannelId) {
      this.getSalesChannelById().subscribe((response: IApplicationResponse) => {
        if (response.isSuccess) {
          this.salesChannelArray = this.getSalesChannel;
          let editResponseObj = new SalesChannelModel(response.resources);
          this.salesChannelArray.push(this.createSalesChannelArray(editResponseObj));
          this.rjxService.setGlobalLoaderProperty(false);
        }
      })
    } else {
      this.salesChannelArray = this.getSalesChannel;
      this.salesChannelArray.push(this.createSalesChannelArray());
      this.rjxService.setGlobalLoaderProperty(false);
    }
  }

  get getSalesChannel(): FormArray {
    if (this.salesChannelForm) {
      return this.salesChannelForm.get("salesChannelArray") as FormArray;
    }
  }

  createSalesChannelArray(commercialProducts?: SalesChannelModel): FormGroup {
    let commercialPorudctData = new SalesChannelModel(commercialProducts ? commercialProducts : undefined);
    let formControls = {};
    Object.keys(commercialPorudctData).forEach((key) => {
      formControls[key] = [{ value: commercialPorudctData[key],disabled:false}, 
      (key === 'salesChannelName'||key=='description' ? [Validators.required] : [])]
    });
    return this.formBuilder.group(formControls);
  }


  addSalesChannel() {
    if (this.getSalesChannel.invalid) {
      return;
    };
    this.salesChannelArray = this.getSalesChannel;
    let salesChannel = new SalesChannelModel();
    this.salesChannelArray.insert(0, this.createSalesChannelArray(salesChannel));
  }

  removeSalesChannel(i: number): void {
      this.getSalesChannel.removeAt(i);
  }

  onFormControlChanges(formControlName: string, formArray: FormArray, formArrayName: string, currentCursorIndex: number): void {
    onFormControlChangesToFindDuplicate(formControlName, formArray, formArrayName, currentCursorIndex, this.salesChannelForm);
  }

  onBlur(formControlName: string, formArray: FormArray, e, index: number) {
    onBlurActionOnDuplicatedFormControl(formControlName, formArray, e, index);
  }

  getSalesChannelById(): Observable<IApplicationResponse> {
    return this.crudService.get(
      ModulesBasedApiSuffix.SALES,
      SalesModuleApiSuffixModels.SALES_API_SALES_CHANNEL,
      this.SalesChannelId, true, null, 1
    );
  }


  createSalesChannelForm(): void {
    this.salesChannelForm = this.formBuilder.group({
      salesChannelArray: this.formBuilder.array([]),
    });
  }

  submit() {
    if (this.salesChannelForm.invalid) {
      return;
    }
    this.addArray = this.salesChannelForm.value.salesChannelArray;
    if (!this.SalesChannelId) {
      this.addArray.forEach((key) => {
        key["createdUserId"] = this.userData.userId;
      })
    }
    if (this.SalesChannelId) {
      this.salesChannelForm.value["salesChannelName"] = this.salesChannelForm.value.salesChannelArray[0].salesChannelName;
      this.salesChannelForm.value["description"] = this.salesChannelForm.value.salesChannelArray[0].description;
      this.salesChannelForm.value["createdUserId"] = this.userData.userId;
      this.salesChannelForm.value["modifiedUserId"] = this.userData.userId
      this.salesChannelForm.value["salesChannelId"] = this.SalesChannelId;
      delete this.salesChannelForm.value["salesChannelArray"];
    }
    let crudService: Observable<IApplicationResponse> = !this.SalesChannelId
      ? this.crudService.create(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_SALES_CHANNEL, this.addArray, 1)
      : this.crudService.update(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_SALES_CHANNEL, this.salesChannelForm.value, 1)

    crudService.subscribe((response: IApplicationResponse) => {
      if (response.isSuccess) {
        this.router.navigate(['/configuration/sales/leads'], { queryParams: { tab: 2 }, skipLocationChange: true });
      }
    });
  }
}